/**
 * English course index: units + lessons for speaking and typing properly.
 */
import { ENGLISH_COURSE_LESSONS } from "./englishCourseLessons";

const t = (en, de) => ({ en, de });

export const LANGUAGE_UNITS = [
  {
    id: "warmup",
    level: "A2",
    title: t("Warm-up", "Aufwärmen"),
    description: t(
      "Quick survival English — then we build real sentences.",
      "Kurzes Survival-Englisch — danach bauen wir echte Sätze."
    ),
    lessonIds: ["wu-greetings", "wu-intro", "wu-survival"],
  },
  {
    id: "sentences",
    level: "A2",
    title: t("Build correct sentences", "Richtige Sätze bauen"),
    description: t(
      "Word order, articles, be/have, present simple, questions & negatives.",
      "Wortstellung, Artikel, be/have, Present Simple, Fragen & Verneinungen."
    ),
    lessonIds: [
      "gr-svo",
      "gr-articles",
      "gr-be",
      "gr-have",
      "gr-present",
      "gr-questions",
      "gr-negatives",
      "gr-pronouns",
    ],
  },
  {
    id: "typing",
    level: "A2",
    title: t("Type it right", "Richtig tippen"),
    description: t(
      "Spelling, capitals, apostrophes, and common German→English mistakes.",
      "Rechtschreibung, Großschreibung, Apostrophe und typische DE→EN-Fehler."
    ),
    lessonIds: ["ty-spelling", "ty-capitals", "ty-apostrophes", "ty-de-mistakes"],
  },
  {
    id: "life",
    level: "A2–B1",
    title: t("Talk about life", "Über das Leben sprechen"),
    description: t(
      "Time, routines, home, school/work, opinions — say and type them.",
      "Zeit, Alltag, Zuhause, Schule/Arbeit, Meinungen — sagen und tippen."
    ),
    lessonIds: ["lf-time", "lf-routine", "lf-home", "lf-school", "lf-opinions"],
  },
  {
    id: "conversation",
    level: "B1",
    title: t("Conversation", "Gespräch"),
    description: t(
      "Real exchanges: shops, directions, help, politeness, messages.",
      "Echte Dialoge: Einkaufen, Wegbeschreibung, Hilfe, Höflichkeit, Nachrichten."
    ),
    lessonIds: ["cv-shop", "cv-directions", "cv-help", "cv-polite", "cv-messages"],
  },
  {
    id: "grammar-speak",
    level: "B1",
    title: t("Grammar for speaking", "Grammatik zum Sprechen"),
    description: t(
      "Past, continuous, future, modals, comparatives, because/when/if.",
      "Past, Continuous, Zukunft, Modalverben, Steigerung, because/when/if."
    ),
    lessonIds: [
      "gs-past",
      "gs-continuous",
      "gs-future",
      "gs-modals",
      "gs-comparatives",
      "gs-clauses",
    ],
  },
  {
    id: "fluent",
    level: "B1",
    title: t("Speak & type fluently", "Flüssig sprechen & tippen"),
    description: t(
      "Longer replies, short messages, say it then type it.",
      "Längere Antworten, kurze Nachrichten, erst sagen, dann tippen."
    ),
    lessonIds: ["fl-replies", "fl-messages", "fl-say-type"],
  },
];

export const LANGUAGE_LESSONS = LANGUAGE_UNITS.flatMap((unit) =>
  unit.lessonIds
    .map((id) => ENGLISH_COURSE_LESSONS[id])
    .filter(Boolean)
);

export const getLanguageLesson = (id) => ENGLISH_COURSE_LESSONS[id] || null;

export const getLessonsForUnit = (unitId) => {
  const unit = LANGUAGE_UNITS.find((item) => item.id === unitId);
  if (!unit) return [];
  return unit.lessonIds.map((id) => ENGLISH_COURSE_LESSONS[id]).filter(Boolean);
};
